export default "__VITE_ASSET__C1Fapvpw__"